import { toast } from "sonner";

function drawCard(ctx, W, H, { name, points, month, company }) {
  const g = ctx.createLinearGradient(0, 0, 0, H);
  g.addColorStop(0, "#f59e0b");
  g.addColorStop(0.55, "#b45309");
  g.addColorStop(1, "#1f2937");
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, W, H);

  ctx.fillStyle = "rgba(255,255,255,0.07)";
  ctx.beginPath(); ctx.arc(W * 0.15, H * 0.12, 200, 0, Math.PI * 2); ctx.fill();
  ctx.beginPath(); ctx.arc(W * 0.9, H * 0.86, 240, 0, Math.PI * 2); ctx.fill();

  ctx.strokeStyle = "rgba(255,255,255,0.4)";
  ctx.lineWidth = 6;
  ctx.strokeRect(48, 48, W - 96, H - 96);

  ctx.textAlign = "center";
  try { ctx.direction = "rtl"; } catch (e) { /* older browsers */ }

  ctx.font = "230px 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif";
  ctx.fillStyle = "#ffffff";
  ctx.fillText("🏆", W / 2, H * 0.32);

  ctx.fillStyle = "#fff8e1";
  ctx.font = "bold 96px 'Segoe UI', Tahoma, Arial, sans-serif";
  ctx.fillText("متصدّر الشهر", W / 2, H * 0.46);

  ctx.fillStyle = "#ffffff";
  ctx.font = "bold 74px 'Segoe UI', Tahoma, Arial, sans-serif";
  ctx.fillText(name || "", W / 2, H * 0.58);

  ctx.fillStyle = "#fde68a";
  ctx.font = "bold 66px 'Segoe UI', Tahoma, Arial, sans-serif";
  ctx.fillText(`${Number(points || 0).toLocaleString("en-US")} نقطة`, W / 2, H * 0.68);

  ctx.fillStyle = "rgba(255,255,255,0.88)";
  ctx.font = "46px 'Segoe UI', Tahoma, Arial, sans-serif";
  ctx.fillText(company || "", W / 2, H * 0.80);

  ctx.fillStyle = "rgba(255,255,255,0.72)";
  ctx.font = "40px 'Segoe UI', Tahoma, Arial, sans-serif";
  ctx.fillText(`شهر ${month || ""}`, W / 2, H * 0.855);

  ctx.fillStyle = "rgba(255,255,255,0.65)";
  ctx.font = "bold 40px 'Segoe UI', Tahoma, Arial, sans-serif";
  ctx.fillText("WorkZone", W / 2, H * 0.93);
}

export async function shareAchievement({ name, points, month, company }) {
  const W = 1080, H = 1350;
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");
  drawCard(ctx, W, H, { name, points, month, company });

  const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
  if (!blob) { toast.error("تعذّر إنشاء الصورة"); return; }
  const file = new File([blob], "top-performer.png", { type: "image/png" });
  const text = `🏆 أنا متصدّر الشهر في ${company || "شركتي"} بـ ${Number(points || 0).toLocaleString("en-US")} نقطة! عبر WorkZone`;

  try {
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title: "متصدّر الشهر", text });
      return;
    }
  } catch (e) {
    if (e && e.name === "AbortError") return; // user cancelled
  }

  // Fallback: download the image then open WhatsApp with the caption
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = "top-performer.png"; a.click();
  URL.revokeObjectURL(url);
  toast.success("تم حفظ صورة الإنجاز — أرفقها في محادثة واتساب");
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
}
